import cn from "clsx";
import { ReactNode } from "react";
import styles from "../reviews.module.scss";
interface Props {
  value: number;
  extra?: ReactNode;
  hiddenScoreNum?: boolean;
}

export default function RatingDisplay({ value, extra, hiddenScoreNum = false }: Props) {
  const fullStars = Math.floor(value);
  const hasHalfStar = value % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  const stars = [];
  for (let i = 0; i < fullStars; i++) {
    stars.push(<i key={i} className={cn(styles.star, styles.full)}></i>); // 实心星星
  }
  if (hasHalfStar) {
    stars.push(<i key="half" className={cn(styles.star, styles.half)}></i>); // 半颗星星
  }
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<i key={i + fullStars + 1} className={cn(styles.star, styles.empty)}></i>); // 空心星星
  }

  return (
    <div className={styles.commentScoreRating}>
      <div className={styles.starIconBox}>{stars}</div>
      <div className={styles.basicFont}>
        {!hiddenScoreNum && <span className={styles.scoreIcon}>4.8</span>}
        {extra}
      </div>
    </div>
  );
}
